import { render, staticRenderFns } from "./PersonalExamPaper.vue?vue&type=template&id=131e2ff6&scoped=true&"
import script from "./PersonalExamPaper.vue?vue&type=script&lang=js&"
export * from "./PersonalExamPaper.vue?vue&type=script&lang=js&"
import style0 from "./PersonalExamPaper.vue?vue&type=style&index=0&id=131e2ff6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e2ff6",
  null
  
)

export default component.exports